import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import { useAccountPageStoreShallow } from "@pages/account/store";
import { useAppDispatch } from "@store";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FOOTER_MENU } from "../constants";
import { useSidebarStoreShallow } from "../store";

export const SidebarFooter = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isOpen } = useSidebarStoreShallow((s) => ({
    isOpen: s.isOpen,
  }));
  const { selectedItem } = useAccountPageStoreShallow((s) => ({
    selectedItem: s.selectedItem,
  }));

  const isAccountPage = pathname.includes("/pages/account");

  const handleClick = useCallback(
    (action: string) => {
      if (action === "invite") {
        navigate("/pages/account", { state: { tab: "users" } });
        return;
      }
      if (action === "settings") {
        navigate("/pages/account", { state: { tab: "general" } });
      }
    },
    [dispatch, navigate],
  );

  return (
    <div
      className={cn(
        "tw-flex tw-w-full tw-flex-col tw-gap-1 tw-bg-blue-50 tw-px-4 tw-py-2 tw-transition-all tw-duration-300 first:tw-border-t first:tw-border-blue-100",
        !isOpen && "tw-px-2",
      )}
    >
      {FOOTER_MENU.map((item) => {
        const Icon = item.icon;
        const isActive =
          isAccountPage &&
          (item.action === "invite"
            ? selectedItem === "users"
            : selectedItem !== "users");
        return (
          <div key={item.action} className="tw-relative tw-w-full">
            <Tooltip placement="right" offset={10}>
              <Tooltip.Trigger asChild>
                <button
                  onClick={() => handleClick(item.action)}
                  type="button"
                  className={cn(
                    "tw-flex tw-h-8 tw-w-full tw-items-center tw-justify-start tw-overflow-hidden tw-rounded-lg tw-p-2 tw-outline-none tw-transition-all tw-duration-300 hover:tw-bg-blue-100/50",
                    {
                      "tw-bg-blue-100 hover:tw-bg-blue-100": isActive,
                      "tw-gap-0": !isOpen,
                    },
                  )}
                >
                  <Icon
                    className={cn(
                      "tw-size-4 tw-shrink-0 tw-text-blue tw-transition-all tw-duration-300",
                      !isActive && "tw-opacity-50",
                    )}
                  />
                  <span
                    className={cn(
                      "tw-text-sans tw-ml-2 tw-overflow-hidden tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-blue tw-transition-all tw-duration-300 tw-ease-in-out",
                      !isOpen &&
                        "tw-pointer-events-none tw-ml-0 !tw-w-0 tw-opacity-0",
                      !isActive && "tw-opacity-50",
                    )}
                  >
                    {item.label}
                  </span>
                </button>
              </Tooltip.Trigger>
              <Tooltip.Content className={cn(isOpen && "tw-hidden")}>
                <Tooltip.Text className="tw-rounded-md tw-bg-primary tw-px-3 tw-py-2 tw-text-sm tw-text-white">
                  {item.label}
                </Tooltip.Text>
              </Tooltip.Content>
            </Tooltip>
            {isActive && (
              <span
                className={cn(
                  "tw-pointer-events-none tw-absolute -tw-right-4 tw-top-0 tw-z-10 tw-h-8 tw-w-1 tw-rounded-l-lg tw-bg-primary tw-transition-all tw-duration-300 tw-ease-in-out",
                  !isOpen && "-tw-right-2",
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
